import type { IAppRegion } from '~/lib/appSettings';
import { useOptionalAppRegion } from './useOptionalAppRegion';

export const useAppRegion = (): IAppRegion => {
  const appRegion = useOptionalAppRegion();
  if (!appRegion) {
    throw new Error('No app region.');
  }

  return appRegion;
};
